import { selectExternalInfos } from '@/domain/external/external.selectors';
import { submitMultipleImpactCo2Answer } from '@/domain/impact-co2/actions/submit-multiple-impact-co2-answer.action';
import { selectAllImpactCo2Answers } from '@/domain/impact-co2/impact-co2.selectors';
import { useDialogConfirm } from '@/ui/components/confirm-dialog/useDialogConfirm';
import { useAppDispatch, useAppSelector } from '@/ui/hook/store';
import { translate } from '@/ui/i18n';
import { Step1Start } from '@/ui/pages/external/components/Step1Start';
import { Step2Form } from '@/ui/pages/external/components/Step2Form';
import { Step3DonePublic } from '@/ui/pages/external/components/Step3DonePublic';
import { useExternalSteps } from '@/ui/pages/external/hooks/useExternalSteps';

import { FormMobilityAccommodation } from './FormMobilityAccommodation';

export function MobilityAccommodation() {
  const dispatch = useAppDispatch();
  const dialogConfirm = useDialogConfirm();

  const answers = useAppSelector(selectAllImpactCo2Answers);
  const { projectId } = useAppSelector(selectExternalInfos);

  const { step, setStep } = useExternalSteps();

  const disableValidate = answers.length <= 0;

  const onClickStartForm = () => {
    setStep('form');
  };

  const onClickValidateSubmitAllAnswers = async () => {
    const response = await dialogConfirm({
      title: translate('External.confirm-submit-answers'),
    });
    if (response === 'confirmed') {
      executeSumbmitAllAnswers();
    }
  };

  const executeSumbmitAllAnswers = async () => {
    try {
      await dispatch(submitMultipleImpactCo2Answer({ projectId, answers }));
      setStep('done');
    } catch (error) {
      console.error(error);
    }
  };

  const onClickAnswerAgain = () => {
    window.location.reload();
  };

  switch (step) {
    case 'start':
      return (
        <Step1Start
          welcomeText={translate('External.welcome-description-survey')}
          onClickStartForm={onClickStartForm}
        />
      );
    case 'form':
      return (
        <Step2Form
          onClickValidate={onClickValidateSubmitAllAnswers}
          disableValidate={disableValidate}
        >
          <FormMobilityAccommodation />
        </Step2Form>
      );
    case 'done':
      return <Step3DonePublic onClickAnswerAgain={onClickAnswerAgain} />;
    default:
      return '';
  }
}
